import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";
import { Loader } from "@/components/Common";
import { MapPin, User, Clock } from "lucide-react";

export default function DayShare() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => {
    axios.get(`${API}/public/day-share/${token}`).then(({ data }) => setData(data)).catch(() => setData(false));
  }, [token]);

  if (data === null) return <div className="min-h-screen bg-background"><Loader /></div>;
  if (data === false) return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center"><h1 className="font-serif text-2xl">Lien invalide</h1>
        <p className="text-stone-500 mt-2">Ce lien de mission n'est plus valide.</p></div></div>
  );

  return (
    <div className="min-h-screen bg-background py-10 px-4">
      <div className="max-w-lg mx-auto">
        <div className="text-center mb-6">
          <div className="eyebrow text-champagne">Jour J · {data.wedding_names}</div>
          <h1 className="font-serif text-3xl mt-1">Missions de {data.person_name || "vous"}</h1>
          <p className="text-sm text-stone-500 mt-1">Voici uniquement les moments dont vous êtes responsable.</p>
        </div>
        {data.days.map((d, i) => (
          <div key={i} className="mb-6">
            <div className="font-serif text-lg mb-2">{d.label}{d.date ? ` · ${d.date}` : ""}</div>
            <div className="space-y-2">
              {d.items.map((it) => (
                <div key={it.id} className="card-lux p-4" data-testid={`share-item-${it.id}`}>
                  <div className="flex items-center gap-2 font-mono text-sm text-stone-800"><Clock className="w-4 h-4 text-champagne" /> {it.start_time}{it.end_time ? ` – ${it.end_time}` : ""}</div>
                  <div className="font-medium mt-1">{it.title}</div>
                  {it.location && <div className="text-sm text-stone-400 flex items-center gap-1"><MapPin className="w-3.5 h-3.5" /> {it.location}</div>}
                  {it.notes && <div className="text-sm text-stone-600 mt-1">📌 {it.notes}</div>}
                  {it.contact_phone && <div className="text-sm text-stone-500 flex items-center gap-1"><User className="w-3.5 h-3.5" /> <a href={`tel:${it.contact_phone}`} className="underline">{it.contact_phone}</a></div>}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
